export default [
  // {
  //   header: 'Administração'
  // },
  // {
  //   title: 'Admin',
  //   icon: 'SettingsIcon',
  // },
  {
    title: 'Administração',
    i18n: 'Admin',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Conteúdo',
        i18n: 'Content',
        icon: 'FileTextIcon',
        children: [
          {
            title: 'Conteúdo',
            i18n: 'Content',
            route: 'admin-content',
          },
          {
            title: 'Assuntos',
            i18n: 'Subject',
            route: 'admin-subject',
          },
          {
            title: 'Categoria',
            i18n: 'Category',
            route: 'admin-category',
          },
          {
            title: 'Característica',
            i18n: 'Characteristic',
            route: 'admin-characteristic',
          },
          {
            title: 'Chapéu',
            i18n: 'Hat',
            route: 'admin-hat',
          },
          {
            title: 'Tipo Relatório',
            i18n: 'ReportType',
            route: 'admin-reportType',
          },
          {
            title: 'Grupos Tipo de Relatório',
            i18n: 'ReportTypeGroups',
            route: 'admin-reportTypeGroups',
          },
          {
            title: 'Tags',
            i18n: 'Tags',
            route: 'admin-tag',
          },
          {
            title: 'Tópico',
            i18n: 'Topic',
            route: 'admin-topic',
          },
          {
            title: 'Idioma',
            i18n: 'Language',
            route: 'admin-language',
          },
          {
            title: 'Siglas',
            i18n: 'Acronyms',
            route: 'admin-acronyms',
          },
          {
            title: 'Referência de ativos',
            i18n: 'AssetReference',
            route: 'admin-asset-reference',
          },
        ],
      },
      {
        title: 'Cadastros base',
        i18n: 'BaseRecords',
        icon: 'SlidersIcon',
        children: [
          {
            title: 'Canal',
            i18n: 'Channel',
            route: 'admin-channel',
          },
          {
            title: 'Origens',
            i18n: 'Origins',
            route: 'admin-origin',
          },
          {
            title: 'Relevância de Conteúdo',
            i18n: 'ContentRelevance',
            route: 'admin-content-relevance',
          },
          {
            title: 'Instâncias SigaWeb',
            i18n: 'Siga Instances',
            route: 'admin-siga-instance',
          },
          {
            title: 'País',
            i18n: 'Country',
            route: 'admin-country',
          },
          {
            title: 'Periodicidade',
            i18n: 'Periodicity',
            route: 'admin-periodicity',
          },
          {
            title: 'Pacote',
            i18n: 'Package',
            route: 'admin-package',
          },
          {
            title: 'Número Lógico',
            i18n: 'LogicalNumber',
            route: 'admin-logical-number',
          },
          {
            title: 'Adobe',
            i18n: 'AdobeAccount',
            route: 'admin-adobe-account',
          },
          {
            title: 'Instituição',
            i18n: 'Institution',
            route: 'admin-institution',
          },
        ],
      },
      {
        title: 'Inteligência artificial',
        i18n: 'ArtificialIntelligence',
        icon: 'CpuIcon',
        children: [
          {
            title: 'Tradução',
            i18n: 'TranslationConfig',
            route: 'admin-translation-config',
          },
          {
            title: 'Gestão de Vetorização',
            i18n: 'VectorizationManagement',
            route: 'admin-vectorization-management',
          },
        ],
      },
      {
        title: 'Clientes',
        i18n: 'Clients',
        icon: 'UsersIcon',
        children: [
          {
            title: 'Clientes',
            i18n: 'Clients',
            route: 'admin-user-client',
          },
          {
            title: 'Assinaturas de Cliente',
            i18n: 'ClientSignature',
            route: 'admin-client-signature',
          },
          {
            title: 'Clientes Deletados',
            i18n: 'Deleted_Clients',
            route: 'admin-deleted-client',
          },
          {
            title: 'Contatos',
            i18n: 'Contact',
            route: 'admin-contact',
          },
          {
            title: 'Pergunte ao Analista',
            i18n: 'AskAnalyst',
            route: 'admin-ask-analyst',
          },
        ],
      },
      {
        title: 'Plataforma Safras',
        i18n: 'SafrasPlatform',
        icon: 'LayoutIcon',
        children: [
          {
            title: 'Layout',
            i18n: 'Layout',
            route: 'admin-layout',
          },
          {
            title: 'Layout Wdma Hist',
            i18n: 'LayoutWdmaHist',
            route: 'admin-layout-wdma-hist',
          },
        ],
      },
      {
        title: 'Comunicação',
        i18n: 'Communication',
        icon: 'SendIcon',
        children: [
          {
            title: 'E-mail',
            i18n: 'Email',
            route: 'admin-sendmail',
          },
          {
            title: 'Push',
            i18n: 'Push',
            route: 'admin-sendpush',
          },
          {
            title: 'Leads',
            i18n: 'Leads',
            route: 'admin-leads',
          },
          {
            title: 'Solicitação de demonstração',
            i18n: 'DemoRequest',
            route: 'admin-demo-request',
          },
        ],
      },
      {
        title: 'Usuários do Publisher',
        i18n: 'PublisherUsers',
        icon: 'ShieldIcon',
        children: [
          {
            title: 'Usuários ADM',
            i18n: 'UsersAdmin',
            route: 'admin-user',
          },
          {
            title: 'Cabeçalhos',
            i18n: 'UserHeader',
            route: 'admin-user-header',
          },
          {
            title: 'Núcleos de Usuário',
            i18n: 'UserCore',
            route: 'admin-user-core',
          },
          {
            title: 'Sincronizar Noticias',
            i18n: 'SynchronizeNews',
            route: 'pages-synchronize',
          },
        ],
      },
      {
        title: 'Logs',
        i18n: 'Logs',
        icon: 'ActivityIcon',
        children: [
          {
            title: 'Acessos de clientes',
            i18n: 'ClientAccess',
            route: 'admin-client-access',
          },
          {
            title: 'Acceptor logs',
            i18n: 'AcceptorLogs',
            route: 'admin-acceptor-logs',
          },
          {
            title: 'Auditlog',
            i18n: 'Auditlog',
            route: 'admin-auditlog',
          },
          {
            title: 'Autenticação de Clientes',
            i18n: 'AuthToken',
            route: 'admin-auth-token',
          },
        ],
      },
      {
        title: 'Serviços',
        i18n: 'Services',
        icon: 'GlobeIcon',
        children: [
          {
            title: 'Geolocalização',
            i18n: 'Geolocation',
            route: 'admin-geolocation',
          },
          {
            title: 'Gerenciador de acessos',
            i18n: 'AccessManager',
            route: 'admin-service-access-manager',
          },
          {
            title: 'MDTP Provider Status',
            i18n: 'MDTPProviderStatus',
            route: 'admin-mdtp-provider-status',
          },
          {
            title: 'Aplicativo Configurações',
            i18n: 'AppConfigSettings',
            route: 'admin-app-config-rules',
          },
        ],
      },
    ],
  },
]
